import { isSupportedCountry } from 'libphonenumber-js'

import { OpenEnded, OpenEndedFormat } from '@/app/module/campaigns/types'

import { validateRe2Regex } from './regex'

type Validation = Pick<OpenEnded, 'format' | 'formatOption' | 'regexp' | 'regexpEnabled'>

export const getOpenEndedValidation = (openEnded?: Validation): OpenEndedFormat | '' =>
  openEnded?.format || ((openEnded?.regexpEnabled ?? !!openEnded?.regexp) ? OpenEndedFormat.Regexp : '')

export const normalizeOpenEndedValidation = <T extends Validation>(
  openEnded: T,
): Omit<T, keyof Validation> & Pick<Validation, 'format' | 'formatOption'> => {
  const { format, formatOption, regexp, regexpEnabled: _regexpEnabled, ...rest } = openEnded
  const validation = getOpenEndedValidation(openEnded)
  if (!validation) {
    return rest
  }

  const option = format ? formatOption : regexp || ''
  return {
    ...rest,
    format: validation,
    ...((validation === OpenEndedFormat.RegionPhoneNumber || validation === OpenEndedFormat.Regexp) &&
    option !== undefined
      ? { formatOption: option }
      : {}),
  }
}

export const validateOpenEndedFormat = (openEnded?: Validation): string => {
  if (!openEnded) {
    return ''
  }

  const normalized = normalizeOpenEndedValidation(openEnded)
  const { format, formatOption = '' } = normalized
  if (format === OpenEndedFormat.RegionPhoneNumber) {
    return isSupportedCountry(formatOption) ? '' : 'Select a country for local phone number validation'
  }
  if (format === OpenEndedFormat.Regexp) {
    return formatOption ? validateRe2Regex(formatOption) : 'Regular expression is required'
  }
  return ''
}
